// src/index.js
import '../public/css/nav.css';

// ------------------------------
// Section: Third‑Party Styles
// ------------------------------
import 'flickity/css/flickity.css';
import 'animate.css/animate.min.css';

// ------------------------------
// Section: Third‑Party Scripts
// ------------------------------
import Flickity from 'flickity';

// ------------------------------
// Section: Helper Functions
// ------------------------------
/**
 * Dynamically load a JS script into the page.
 * @param {string} src
 * @param {object} attrs  Any additional attrs to set (e.g. { defer: true })
 * @returns {HTMLScriptElement}
 */
function loadScript(src, attrs = {}) {
  const script = document.createElement('script');
  script.src = src;
  Object.entries(attrs).forEach(([k, v]) => script.setAttribute(k, v));
  document.body.appendChild(script);
  return script;
}

/**
 * Dynamically load a CSS stylesheet into the page.
 * @param {string} href
 */
function loadStylesheet(href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

// ------------------------------
// Section: DOMContentLoaded
// ------------------------------
document.addEventListener('DOMContentLoaded', () => {

  // ------------------------------
  // Subsection: Flickity Carousels
  // ------------------------------
  const carousels = document.querySelectorAll('.js-flickity');
  if (carousels.length > 0) {
    carousels.forEach(el => {
      // 1) parse JSON options or fallback
      let opts = {};
      const raw = el.getAttribute('data-flickity-options');
      if (raw) {
        try { opts = JSON.parse(raw); }
        catch (e) { console.warn('Invalid data-flickity-options JSON:', e); }
      } else {
        opts = { wrapAround: true, draggable: true };
      }

      // 2) initialize Flickity
      const flkty = new Flickity(el, opts);

      // 3) wire‑up optional auto‑scroll
      if (el.hasAttribute('data-auto-scroll')) {
        let isAnimating = true, isHovering = false;
        function animate() {
          if (!isAnimating) return;
          flkty.x -= 0.2;
          flkty.settle(flkty.x);
          requestAnimationFrame(animate);
        }
        el.addEventListener('mouseenter', () => { isAnimating = false; });
        el.addEventListener('mouseleave', () => {
          isHovering = false;
          isAnimating = true;
          animate();
        });
        flkty.on('dragStart', () => isAnimating = false);
        flkty.on('dragEnd',   () => { if (!isHovering) animate(); });
        animate();
      }

      // 4) reveal once ready
      el.style.visibility = 'visible';
    });
  }

  // ------------------------------
  // Subsection: Calendly Popup Loader
  // ------------------------------
  document.querySelectorAll('[data-calendly-url]').forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault();
      const url = btn.dataset.calendlyUrl;
    
      import(/* webpackChunkName: "calendly" */ './calendly').then(() => {
        if (!window.Calendly) {
          loadStylesheet('https://assets.calendly.com/assets/external/widget.css');
          loadScript('https://assets.calendly.com/assets/external/widget.js', { defer: true })
            .onload = () => Calendly.initPopupWidget({ url });
        } else {
          Calendly.initPopupWidget({ url });
        }
      });
    });    
  });

});
